// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"96ddadee","498":"e74d17a5","703":"7b00e57e","787":"273beb02"}[chunkId] + ".chunk.js";
};